<template>
  <form action="#"
    class="modal-auth__form"
    @submit.prevent="send">
    <div class="modal-auth__form-grid">
      <div class="modal-auth__form-row">
        <form-input v-model="data.family"
          placeholder="Фамилия" />
        <form-input v-model="data.name"
          placeholder="Имя" />
      </div>
      <div class="modal-auth__form-row">
        <form-check v-model="noSurname">
          Нет отчества
        </form-check>
        <form-input v-if="!noSurname"
          v-model="data.surname"
          placeholder="Отчество" />
      </div>
      <div class="modal-auth__form-row">
        <form-datepicker v-model="data.birthday"
          placeholder="Дата рождения"
          flow="birthday" />
        <form-input v-model="data.email"
          placeholder="Email"
          type="email" />
      </div>
      <div class="modal-auth__form-row">
        <form-input v-model="data.phone"
          placeholder="Телефон"
          type="tel" />

        <form-input v-model="data.password"
          label="Пароль"
          placeholder="Пароль"
          type="password" />
      </div>

      <div class="modal-auth__form-col">
        <form-check v-model="data.soglasie_actions" checked>Я согласен получать уведомления о новых акциях и предложениях нашей компании</form-check>
        <form-check v-model="data.soglasie" checked>Я согласен на обработку персональных данных и согласен с 
          <a class="modal-auth__form-link" href="/politika" target="_blank">политикой обработки персональных данных</a>
        </form-check>
      </div>
      

      <div class="modal-auth__form-actions">
        <app-button
          :sending="loading"
          type="submit">
          Отправить заявку
        </app-button>
      </div>
    </div>

  </form>
</template>

<script>
import { reactive, ref } from 'vue';
import { useNotification } from '@kyvg/vue3-notification';

import api from '@/plugins/api';

import FormInput from '@/components/form/FormInput.vue';
import FormDatepicker from '@/components/form/FormDatepicker.vue';
import FormCheck from '@/components/form/FormCheck.vue';
import AppButton from '@/components/ui/AppButton.vue';

export default {
  components: {
    FormInput,
    FormDatepicker,
    FormCheck,
    AppButton,
  },
  emits: ['go-to'],
  setup(props, { emit }) {
    const loading = ref(false);
    const { notify } = useNotification();

    const data = reactive({
      name: '',
      family: '',
      surname: '',
      birthday: '',
      phone: '',
      email: '',
      password: '',
      soglasie_actions: true,
      soglasie: true,
    });

    const noSurname = ref(false);
    const agree = ref(false);

    const send = () => {
      loading.value = true;

      if (noSurname.value) {
        data.surname = '';
      }

      api.post('/api/clientRegister', data).then(({ data }) => {
        if (data.errors) {
          if(data.errors.email){
            notify({
              title: 'Ошибка!',
              text: data.errors.email,
              type: 'error',
            });
          }else{
            notify({
              title: 'Ошибка!',
              text: 'Не заполнены обязательные поля',
              type: 'error',
            });
          }
        } else {
          notify({
            title: 'Успех!',
            text: 'Регистрация прошла успешно. Пожалуйста, авторизуйтесь',
            type: 'success',
          });

          emit('go-to', 'auth');
        }
      }).finally(() => {
        loading.value = false;
      });
    };

    return { loading, data, noSurname, agree, send };
  },
};
</script>
